/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { AppState } from "Dataflows/Reducers";
import {
  ISubmitCsvFileStatus,
  IUploadCsvFileValidation,
} from "Interfaces/SA/IUploadCSVFileRequest";

export const getState = (state: AppState): AppState => state;

/**
 * Returns state of csv upload
 * @param appState
 * @returns {boolean}
 */
export const getCsvUploadState = (state: AppState): boolean =>
  state.saProgramStatusState.isUploading;

/**
 * Returns state of validation Response
 * @param appState
 * @returns {IUploadCsvFileValidation}
 */
export const getCsvUploadErrors = (state: AppState): IUploadCsvFileValidation =>
  state.saProgramStatusState.validationResponse;

/**
 * Returns state of submit Response
 * @param appState
 * @returns {ISubmitCsvFileStatus}
 */
export const getCsvSubmitStatus = (state: AppState): ISubmitCsvFileStatus =>
  state.saProgramStatusState.submitResponse;
